var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBannerIcon = function SvgBannerIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#FFD6CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "url(#paint0_linear_56_31662)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13C19 14.1046 18.1046 15 17 15C15.8954 15 15 14.1046 15 13C15 11.8954 15.8954 11 17 11C18.1046 11 19 11.8954 19 13Z",
    fill: "#FFF1EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20C22 21.1046 21.1046 22 20 22C18.8954 22 18 21.1046 18 20C18 18.8954 18.8954 18 20 18C21.1046 18 22 18.8954 22 20Z",
    fill: "#FFF1EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 13C27 14.1046 26.1046 15 25 15C23.8954 15 23 14.1046 23 13C23 11.8954 23.8954 11 25 11C26.1046 11 27 11.8954 27 13Z",
    fill: "#FFF1EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30 20C30 21.1046 29.1046 22 28 22C26.8954 22 26 21.1046 26 20C26 18.8954 26.8954 18 28 18C29.1046 18 30 18.8954 30 20Z",
    fill: "#FFF1EE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0004 16.5723H12C11.7348 16.5723 11.4804 16.6776 11.2929 16.8652C11.1054 17.0527 11 17.307 11 17.5723V30.5723L15 26.5723H24C24.2652 26.5723 24.5196 26.4669 24.7071 26.2794C24.8946 26.0918 25 25.8375 25 25.5723V22.9998H23V24.5723H14.17L13 25.7423V18.5723H15.7782L15.0004 16.5723Z",
    fill: "#FFF1EE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6102 13.4363L21.4573 19.2504H27.9999V20.7504H19.5054L16.3105 13.2958L17.6893 12.7049L20.1643 18.4799L24.3896 12.5645L25.6102 13.4363Z",
    fill: "#FFF1EE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_56_31662",
    x1: 0,
    y1: 0,
    x2: 48.1258,
    y2: 17.0103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FF7557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E37BD3"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBannerIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "banner-icon.4d7cd726216a52e470d006f6db524fd7.svg";